module.exports = __webpack_public_path__ + "static/media/starlla4.b0224b33.jpg";